import type { PatType } from "modules/user-profile/types"
import type { Role } from "model/state"

export interface AccountPatToken {
  id: string
  tokenType: PatType
  prefix: string
  source: "user" | "system"
  createdAt: string
  lastUsedAt: string | null
  rotatedAt: string | null
}

export interface AccountPatMember {
  userId: string
  name: string
  email: string
  role: Role
  canCreateReadWrite: boolean
  tokens: AccountPatToken[]
}

export interface AccountPatListResponse {
  patEnabled: boolean
  members: AccountPatMember[]
}

export interface AccountPatCreateResponse {
  token: {
    id: string
    tokenType: PatType
    prefix: string
    createdAt: string
    secret: string
  }
}

export interface AccountPatRevealResponse {
  secret: string
}

export interface AccountPatRotateResponse {
  token: {
    id: string
    tokenType: PatType
    prefix: string
    rotatedAt: string
    secret: string
  }
}

export interface CreateAccountPatInput {
  userId: string
  type: PatType
}

/** Addresses an empty slot, which has no token id of its own to be named by. */
export function patSlotKey(userId: string, tokenType: PatType): string {
  return `${userId}:${tokenType}`
}

/**
 * The slots with a mutation in flight, named the two ways a slot can be addressed: by the id
 * of the token it holds, or — when it is still empty — by the `patSlotKey` of the member and
 * scope a create is about to fill.
 *
 * Both are sets, not single values: several slots can legitimately have a request in flight at
 * once, and a shape that holds only the newest one drops the earlier slots back to enabled
 * while their requests are still running.
 */
export interface PatPendingState {
  tokenIds: ReadonlySet<string>
  creates: ReadonlySet<string>
}
